export default "__VITE_ASSET__BfrcSdWF__"